<template>
    <v-radio
        :value="value"
        class="habiteo-body-2 radio-button"
        color="green darken-2"
        :ripple="false"
        @click.prevent="selectValue"
        :checked="isChecked"
    >
        <template
            v-slot:label
        >
            {{ label }}
            <template v-if="sublabel">
                <br>
                {{ sublabel }}
            </template>
        </template>
    </v-radio>
</template>

<script>
    export default {
        name: 'StepRadioBtn',
        props: {
            label: {
                type: String,
                required: true
            },
            sublabel: {
                type: String,
                required: false
            },
            value: {
                type: Number,
                required: true
            },
            isChecked: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            selectValue(val) {
                this.$emit('select-value', val);
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/StepRadioBtn.vue